import {batch, useDispatch, useSelector} from "react-redux";
import {optionAction} from "../../../../redux/store";
import {useNavigate, useParams} from "react-router-dom";


const useOptionController = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();

  const navData = useSelector(state => state.menuOpen.navData);
  const langData = useSelector(state => state.theme.langData);
  const navigationList = navData && navData.processedNavData ? navData.processedNavData : [];
  const connectMode = useSelector(state => state.theme.connectMode);
  const currentDepth = useSelector(state => state.optionWindow.dataDepth);



  const slideToSubHandler = (data) => {
    const navigationItem = navigationList.find(nav => nav.id === data.id);
    if(!navigationItem) return;

    let targetStep = null;

    if (data.stepId) {
      targetStep = navigationItem.navigationSteps.find(step => {
        if (step.stepType === "COLOR") {
          return step.stepItems.some(item => item.id === data.stepId);
        }
        return step.id === data.stepId;
      })

      if (targetStep && targetStep.stepType === "COLOR") {
        const clickedItem = targetStep.stepItems.find(item => item.id === data.stepId);
        const colorPairs = [
          ["EXTERIOR_COLOR_PRIMARY", "EXTERIOR_COLOR_SECONDARY"],
          ["INTERIOR_KEY_COLOR", "INTERIOR_SECONDARY_COLOR", "INTERIOR_THIRD_COLOR"]
        ];
        const targetPair = colorPairs.find(pair => pair.includes(clickedItem?.colorTarget));

        targetStep = {
          ...targetStep,
          stepItems: targetStep.stepItems.filter(item =>
            item.id === data.stepId || (targetPair && targetPair.includes(item.colorTarget))
          )
        };
      }
    }

    const parentNavigation = navigationList.find(nav => nav.id === data.parentId) || navigationItem;
    const cleanedItemId = parentNavigation.linkPath?.replaceAll(/[\{\}\[\]\/?.,;:|\)*~`!^\+<>@\#$%&\\\=\(\'\"]/gi, "");


    if (connectMode === "web") {
      navigate(`/${langData.lang}/${params.id}/configurator/${parentNavigation.linkPath}`);
    }

    batch(() => {
      dispatch(optionAction.setCurrentNavigation(cleanedItemId));
      dispatch(optionAction.setChildNavigationData({
        ...navigationItem,
        navigationSteps: targetStep || navigationItem.navigationSteps,
        colorTarget: data.colorTarget,
        backToDepth: currentDepth
      }));
      dispatch(optionAction.setDataDepth(data.targetDepth || "3"));
    });

  }



  const slideToMainHandler = (targetDepth) => {
    batch(() => {
      dispatch(optionAction.setDataDepth(targetDepth));
      if (targetDepth === "1") {
        dispatch(optionAction.setChildNavigationData(""));
        dispatch(optionAction.setCurrentStep({}));
      }
    })

  }


  return {
    slideToSubHandler, slideToMainHandler
  }

}

export default useOptionController;
